import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useDiagramSnapshot = () => {
  const { projectId } = useRouterParams();
  return useReduxSelector(diagramSnapshotSelector(projectId));
};
